import {
  AUTHORIZATION_RID,
  AUTO_DATA_UPDATE_RID,
  GAME_TIMES_RID,
  LAST_RESULTS_RID,
  GET_SERVER_TIME_RID
} from "./RequestDatas";
import Utils from "../utils/Utils";

const SOCKET_URL = "wss://eu-swarm-virtual-ws.betconstruct.com/";
const SOCKET_URL_STAGING = "wss://swarm-virtuals-staging.betconstruct.com";
let webSocket;

export default class RequestManager {
  static SOCKET_CLOSED_EVENT = "SOCKET_CLOSED_EVENT";
  static AUTHORIZATION_EVENT = "AUTHORIZATION_EVENT";
  static GAME_TIMES_EVENT = "GAME_TIMES_EVENT";
  static LAST_RESULTS_EVENT = "LAST_RESULTS_EVENT";
  static GET_SERVER_TIME_EVENT = "GET_SERVER_TIME_EVENT"

  static AUTO_GAME_TIMES_DATA = "AUTO_GAME_TIMES_DATA";
  static AUTO_REMOVE_GAME = "AUTO_REMOVE_GAME";
  static AUTO_GAME_RESULT = "AUTO_GAME_RESULT";

  static instance = null;

  constructor() {
    this.setupWebSocket();
  }

  static getInstance() {
    if (RequestManager.instance === null) {
      RequestManager.instance = new RequestManager();
    }

    return RequestManager.instance;
  }

  setupWebSocket() {
    const socketURL = Utils.STAGING_MODE /*|| Utils.DEV_MODE*/ ? SOCKET_URL_STAGING : SOCKET_URL;
    webSocket = new WebSocket(socketURL);

    webSocket.onmessage = (event) => {
      const response = JSON.parse(event.data);
      const requestID = response.rid.toString();
      let socketEvent;

      switch (requestID) {
        case AUTHORIZATION_RID:
          socketEvent = new CustomEvent(RequestManager.AUTHORIZATION_EVENT, {
            detail: response,
          });
          break;
        case GAME_TIMES_RID:
          socketEvent = new CustomEvent(RequestManager.GAME_TIMES_EVENT, {
            detail: response,
          });
          break;
        case LAST_RESULTS_RID:
          socketEvent = new CustomEvent(RequestManager.LAST_RESULTS_EVENT, {
            detail: response,
          });
          break;
        case GET_SERVER_TIME_RID:
          socketEvent = new CustomEvent(RequestManager.GET_SERVER_TIME_EVENT, {
            detail: response,
          });
          break;
        case AUTO_DATA_UPDATE_RID:
          this.handleAutoEvent(response);
          return;
        default:
          console.log("REQUEST CANT DEFINED: ", response);
      }

      if (socketEvent) {
        webSocket.dispatchEvent(socketEvent);
      }
    };

    webSocket.onclose = () => {
      RequestManager.instance = null;
      webSocket.dispatchEvent(
        new CustomEvent(RequestManager.SOCKET_CLOSED_EVENT)
      );
      webSocket.close();
    };
  }

  handleAutoEvent({ data }) {
    // console.log('>> AUTO DATA:', JSON.stringify(data));
    const dataObjects = Object.keys(data).map((key) => data[key]);
    let dataString;
    let event;

    dataObjects.forEach((dataObject) => {
      dataString = JSON.stringify(dataObject);

      if (dataString.includes("number")) {
        event = new CustomEvent(RequestManager.AUTO_GAME_RESULT, {
          detail: dataObject,
        });
      } else if (dataString.includes("start_ts")) {
        event = new CustomEvent(RequestManager.AUTO_GAME_TIMES_DATA, {
          detail: dataObject,
        });
      } else if (dataString.includes("null")) {
        event = new CustomEvent(RequestManager.AUTO_REMOVE_GAME, {
          detail: dataObject,
        });
      }

      try {
        webSocket.dispatchEvent(event);
      } catch {
        console.log(">> FAILED DISPATCHING LIVE EVENT:", dataString);
      }
    });
  }

  get webSocket() {
    return webSocket;
  }
}
